import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-white" data-id="element-105">
      <FadeIn data-id="element-106">
        <div className="flex items-center gap-3 mb-6" data-id="element-107">
          <AlertCircle className="w-8 h-8 text-[#E8872B]" data-id="element-108" />
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26]" data-id="element-109">
            El problema real: no es tu mascota. Es el ciclo.
          </h2>
        </div>

        <div className="prose prose-lg text-[#2D2A26]/80 max-w-none" data-id="element-110">
          <p className="mb-6" data-id="element-111">
            En apartamento, el olor a mascota no vive en un solo sitio. Se{' '}
            <strong data-id="element-112">mueve</strong>. Se pega a telas. Se queda en zócalos. Se
            reactiva con humedad.
          </p>

          <p className="mb-8" data-id="element-113">
            Y si hay una fuente constante (cama, arenero, rincones), tu casa
            puede oler aunque hayas limpiado “ayer”.
          </p>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-114">
            <p className="font-semibold mb-4 text-[#2D2A26]" data-id="element-115">
              Lo que pasa es que la mayoría hace lo mismo:
            </p>
            <ul className="space-y-3" data-id="element-116">
              <li className="flex items-center gap-3" data-id="element-117">
                <span className="w-2 h-2 bg-[#E8872B] rounded-full" data-id="element-118"></span>
                <span data-id="element-119">Pone un aromatizante</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-120">
                <span className="w-2 h-2 bg-[#E8872B] rounded-full" data-id="element-121"></span>
                <span data-id="element-122">Trapea más fuerte</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-123">
                <span className="w-2 h-2 bg-[#E8872B] rounded-full" data-id="element-124"></span>
                <span data-id="element-125">Lava una cobija al azar</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-126">
                <span className="w-2 h-2 bg-[#E8872B] rounded-full" data-id="element-127"></span>
                <span data-id="element-128">Compra otro spray "mágico"</span>
              </li>
            </ul>
          </div>

          <p className="mt-8 text-xl font-bold text-[#2D2A26] text-center" data-id="element-129">
            Eso no es un plan. Es adivinanza.
          </p>
        </div>
      </FadeIn>
    </Section>;
}